export const ZONES = {
  PENINSULA: 'PENINSULA',
  BALEARES: 'BALEARES',
  CANARIAS: 'CANARIAS',
}

export const ZONE_POSTAL_CODES = {
  [ZONES.PENINSULA]: '08001',
  [ZONES.BALEARES]: '07001',
  [ZONES.CANARIAS]: '35001',
}

export const initialSpecs = {
  tension: '',
  extraAdditionalCost: 0,
  panels: null,
  roofType: 'COPLANAR',
  panelsModel: 'silver',
  clientType: 'particular',
  energyReform: { hasEnergyReform: false },
  energyEfficiencyCertificateQuantity: 0,
  zone: ZONES.PENINSULA,
  assets: [],
  discounts: { panels: 0, battery: 0, evCharger: 0, certificate: 0 },
}

export const initialAppliedDiscounts = {
  panels: 0,
  battery: 0,
  evCharger: 0,
  certificate: 0,
}

export const initialState = {
  specs: { ...initialSpecs },
  simulation: null,
  lastSimulatedPanels: null,
  installationTax: '',
  taxType: '',
  assetsCatalog: [],
  isLoadingCatalog: false,
  catalogError: false,
  isLoading: false,
  error: null,
  appliedDiscounts: { ...initialAppliedDiscounts },
  isApplyingDiscount: false,
  applyDiscountError: null,
}

export default () => ({
  ...initialState,
  specs: { ...initialSpecs },
  appliedDiscounts: { ...initialAppliedDiscounts },
})
